import React from 'react';
import Person from '@mui/icons-material/Person';
import HoverEnlargePhoto, {
  ACTIVITY_LOGS_PHOTO_PREVIEW_SIZE,
} from 'pages/components/HoverEnlargePhoto/HoverEnlargePhoto';
import * as S from './LogTable.styled';

/** Small face chip with delayed hover enlarge — activityLogs table + report preview. */
const UsernamePhotoWithPreview = ({
  src,
  ring,
  fallback,
}: {
  src?: string,
  ring?: boolean,
  fallback?: React.ReactNode,
}) => {
  const photoSrc = String(src || '').trim();
  return (
    <HoverEnlargePhoto
      src={photoSrc}
      previewSize={ACTIVITY_LOGS_PHOTO_PREVIEW_SIZE}
      previewShape="circle"
    >
      {photoSrc ? (
        <S.UsernamePhoto src={photoSrc} alt="" $ring={ring} />
      ) : (
        fallback || (
          <S.UsernamePhotoFallback aria-hidden $ring={ring}>
            <Person />
          </S.UsernamePhotoFallback>
        )
      )}
    </HoverEnlargePhoto>
  );
};

export default UsernamePhotoWithPreview;
